var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gf_flex gf_justify-c-between"},[_c('ArticleEditor',{attrs:{"articleId":_vm.$route.params.articleId,"width":"full"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }